<template>
    <div
        data-testid="page:main:deposits"
        class="deposits no-overflow"
    >
        <MainSectionSlider :slides-data="modifySlides(depositsModel.slidesData)" />
        <UIAdvantages :advantages="depositsModel.depositsAdvantages" />
        <div class="deposits-deposits-types">
            <div class="wrapper">
                <h2 class="h2">Виды вкладов</h2>
                <div class="deposits-deposits-types__slider">
                    <OfferSlider
                        v-for="{slotName} in depositsModel.offerTabsData"
                        :key="slotName"
                        :slides-data="modifySlides(depositsModel[slotName])"
                    />
                </div>
            </div>
        </div>
        <div class="deposits-services">
            <div class="wrapper">
                <h2 class="h2">Полезные сервисы</h2>
                <div class="deposits-services-wrapper flex flex-wrap justify-start">
                    <div
                        v-for="{title, link, buttonLabel} in depositsModel.depositsServices"
                        :key="link"
                        class="deposits-service flex flex-column"
                    >
                        <h4
                            class="deposits-service__title"
                            v-html="title"
                        />
                        <UIButton
                            :label="buttonLabel"
                            theme="monochrome"
                            @click="onLinkServiceHandler(link)"
                        >
                            <template #icon>
                                <CheveronSvg />
                            </template>
                        </UIButton>
                    </div>
                </div>
            </div>
        </div>
        <div
            id="deposits-calc"
            class="deposits-calculator"
        >
            <div class="wrapper">
                <h2 class="h2">Подобрать вклад</h2>
                <DepositCalculator
                    :deposits="calcDeposits"
                    @pickup-deposit="onShowFoundDepositsHandler"
                />
            </div>
        </div>
        <div class="deposits-result">
            <div class="wrapper">
                <DepositResults
                    :deposits="calculatedDeposits"
                    :is-scroll-allow="isScrollAllow"
                    @scroll-end="isScrollAllow = false"
                />
            </div>
        </div>
        <div class="deposits-banner">
            <div class="wrapper">
                <DepositInsuranceBanner theme="monochrome" />
            </div>
        </div>
        <div class="deposits-additional">
            <div class="wrapper">
                <DepositsInfo v-bind="depositInfo" />
                <CallbackForm
                    :text="callbackFormText"
                    column
                    class="deposits-callback-form"
                    call-center-label="deposits"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, computed, ref} from 'vue';
import {DepositCalculator, DepositResults, UIButton} from '@cibsite/ui-components-vue2';

import {useSlidesModify} from '@/core/composables/useSlidesModify';
import {useDepositResult} from '@/core/composables/useDepositResult';
import {useIndividualDepositStore} from '@/stores/calculators/individual-deposit';
import * as DepositsModel from '@/core/models/pages/for-individuals/deposits/DepositsModel';

import MainSectionSlider from '@/components/Sliders/MainSectionSlider/MainSectionSlider.vue';
import OfferSlider from '@/components/Sliders/OfferSlider/OfferSlider.vue';
import CallbackForm from '@/components/Forms/CallbackForm.vue';
import DepositsInfo from '@/components/Pages/ForIndividuals/Deposits/DepositsInfo.vue';
import CheveronSvg from '@/assets/images/icons/arrows/chevron-down-black.svg?inline';
import DepositInsuranceBanner from '@/components/Banners/DepositInsuranceBanner.vue';
import UIAdvantages from '@/components/UI-components/Advantages/UIAdvantages.vue';

export default defineComponent({
    name: 'DepositsPage',
    components: {
        DepositCalculator,
        UIButton,
        DepositResults,
        MainSectionSlider,
        OfferSlider,
        CallbackForm,
        DepositsInfo,
        DepositInsuranceBanner,
        UIAdvantages,
        CheveronSvg,
    },
    setup() {
        const individualDepositStore = useIndividualDepositStore();
        const {modifySlides} = useSlidesModify();
        const deposits = computed(() => individualDepositStore.deposits);
        const depositResults = useDepositResult();

        const activeTab = ref(0);

        function onLinkServiceHandler(link) {
            window.open(link, '_blank');
        }

        return {
            depositsModel: DepositsModel,
            depositInfo: {
                tabsData: DepositsModel.infoTabsData,
                infoDocs: DepositsModel.infoDocs,
                depositsTemplates: DepositsModel.depositsTemplates,
                rubProlongationsTableData: DepositsModel.rubProlongationsTableData,
            },
            callbackFormText: {
                title: `
                    Возникли вопросы? Оставьте свой
                    номер телефона, мы перезвоним вам
                `,
                submitingMessage: `
                    Ваша заявка принята, наши специалисты свяжутся с&nbsp;вами в&nbsp;ближайшее время.
                `,
            },
            deposits,
            activeTab,
            calcDeposits: individualDepositStore.calculatorDeposits,
            calculatedDeposits: depositResults.calculatedDeposits,
            isScrollAllow: depositResults.isScrollAllow,
            onShowFoundDepositsHandler: depositResults.onShowFoundDepositsHandler,
            modifySlides,
            onLinkServiceHandler,
        };
    },
    asyncData({route, redirect}) {
        if (route.hash === '#cur') {
            redirect('/for-individuals/deposits/currency-deposits');

            return;
        }

        const individualDepositStore = useIndividualDepositStore();

        !individualDepositStore.calculatorDeposits?.length && individualDepositStore.fetchDeposits();

        return {};
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/pages/for-individuals/deposits/deposits';
</style>
